var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sort-a",
    d: "M0 .483h9v5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 0c.827 0 1.5.673 1.5 1.5a.5.5 0 0 1-1 0 .5.5 0 0 0-.5-.5.5.5 0 0 1 0-1M13.5 0a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5.5.5 0 0 1-1 0c0-.827.673-1.5 1.5-1.5M22.5 3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5M18.5 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M18.5 10h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M15.5 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M15.5 10h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1M12.5 9a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 0 1c-.827 0-1.5-.673-1.5-1.5a.5.5 0 0 1 .5-.5M12.5 6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5M22.5 9a.5.5 0 0 1 .5.5c0 .827-.673 1.5-1.5 1.5a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5M22.5 6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5M12.5 3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5M21.5 23a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8zm-8-10h8c.827 0 1.5.673 1.5 1.5v8c0 .827-.673 1.5-1.5 1.5h-8c-.827 0-1.5-.673-1.5-1.5v-8c0-.827.673-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 4.5 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sort-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sort-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 5.483a.502.502 0 0 1-.354-.146l-4-4A.502.502 0 0 1 .854.629L4.5 4.276 8.146.629a.502.502 0 0 1 .708.708l-4 4a.502.502 0 0 1-.354.146",
    mask: "url(#sort-b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 4.517a.5.5 0 0 1 .5.5V20.5a.5.5 0 0 1-1 0V5.017a.5.5 0 0 1 .5-.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.7ccd764568fd15690466fc866958300b.svg";
export { ForwardRef as ReactComponent };